<div *ngIf="reportType === 'Briefly-Officer'">
  <div id="print-section">

    <!-- ================= HEADER ================= -->
    <table style="width:100%;border-collapse:collapse;border:1px solid black;">
      <tr>
        <th style="font-size:18px;font-weight:bold;text-align:center;padding:8px;border:1px solid black;">
          हिंदुस्तान प्रकाशन संस्था
        </th>
        <th style="font-size:18px;font-weight:bold;text-align:center;padding:8px;border:1px solid black;">
          Book Registration Ledger Report
        </th>
        <th style="font-size:18px;text-align:right;padding:8px;border:1px solid black;">
          दिनांक {{ currentDate | date:'dd-MM-yyyy' }}
        </th>
      </tr>

      <tr>
        <th style="padding:8px;font-weight:bold;font-size:18px;text-align:center;border:1px solid black;">
          विवेक पुस्तक प्रकाशन
        </th>
        <th style="font-size:18px;font-weight:bold;text-align:center;padding:8px;border:1px solid black;">
          Book Wise
        </th>
        <th style="font-size:16px;text-align:right;padding:8px;border:1px solid black;">
          Date : From {{ startDate | date:'dd-MM-yyyy' }} To {{ endDate | date:'dd-MM-yyyy' }}
        </th>
      </tr>
    </table>

    <!-- ================= DATA TABLE ================= -->
    <table style="width:100%;border-collapse:collapse;border:1px solid black;font-size:13px;">

      <!-- ===== COLUMN HEADER ===== -->
      <thead>
        <tr>
          <th style="border:1px solid black;">Sr</th>
          <th style="border:1px solid black;">Book Name</th>
          <th style="border:1px solid black;">Sale Copies</th>
          <th style="border:1px solid black;">Ret Copies</th>
          <th style="border:1px solid black;">Comp Copies</th>
          <th style="border:1px solid black;">Total Billing Amt</th>
          <th style="border:1px solid black;">Paid Amount</th>
           <th style="border:1px solid black;">Credit Amount</th> 
          <th style="border:1px solid black;">Unpaid Amount</th>
          <th style="border:1px solid black;">Commission</th>
        </tr>
      </thead>

      <!-- ===== BODY ===== -->
      <tbody>
        <tr *ngFor="let d of filterData; let i = index">
          <td style="border:1px solid black;text-align:center;">
            {{ i + 1 }}
          </td>

          <td style="border:1px solid black;width:20%;">
            {{ d.book_name || '-' }}
          </td>

          <td style="border:1px solid black;text-align:right;">
            {{ d.sale_copies }}
          </td>

          <td style="border:1px solid black;text-align:right;">
            {{ d.return_copies }}
          </td>

          <td style="border:1px solid black;text-align:right;">
            {{ d.complimentary_copies }}
          </td>

          <td style="border:1px solid black;text-align:right;">
            {{ d.gross_total }}
          </td>

           <td style="border:1px solid black;text-align:right;">
             {{ d.received_amt }}
          </td> 
            <td style="border:1px solid black;text-align:right;">
             {{ d.credit_amt }}
          </td>

          <td style="border:1px solid black;text-align:right;">
            {{ d.remaining_amt }}
          </td>

          <td style="border:1px solid black;text-align:right;">
            {{ d.commission_amt }}
          </td>
        </tr>

        <!-- ===== NO RECORD ===== -->
        <tr *ngIf="filterData.length === 0">
          <td colspan="9" style="text-align:center;font-weight:bold;border:1px solid black;">
            No records found
          </td>
        </tr>
      </tbody>

      <!-- ================= TOTAL ================= -->
     <tfoot>
  <tr style="background:#c8753f;font-weight:bold;">
    <td colspan="2" style="border:1px solid black;text-align:right;">
      Total
    </td>

    <td style="border:1px solid black;text-align:right;">
      {{ TotalSaleCopies }}
    </td>

    <td style="border:1px solid black;text-align:right;">
      {{ TotalReturnCopies }}
    </td>

    <td style="border:1px solid black;text-align:right;">
      {{ TotalComplimentary }}
    </td>

    <td style="border:1px solid black;text-align:right;">
      {{ TotalAmount }}
    </td>

    <!-- ✅ PAID -->
    <td style="border:1px solid black;text-align:right;">
      {{ TotalReceipt }}
    </td>

    <!-- ✅ CREDIT (MISSING EARLIER) -->
    <td style="border:1px solid black;text-align:right;">
      {{ TotalCredit }}
    </td>

    <!-- ✅ UNPAID -->
    <td style="border:1px solid black;text-align:right;">
      {{ TotalPending }}
    </td>

    <td style="border:1px solid black;text-align:right;">
      {{ TotalCommission }}
    </td>
  </tr>
</tfoot>


    </table>
  </div>

  <!-- ================= BUTTONS ================= -->
  <div class="noPrint text-end mt-3">
    <button class="btn btn-primary me-2" (click)="exportExcel('Briefly_Officer_Report')">
      Export
    </button>
    <button class="btn btn-primary me-2" (click)="printPage()">
      Print
    </button>
    <button class="btn btn-secondary" mat-dialog-close>
      Close
    </button>
  </div>
</div>
